var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSuccessMark = function SvgSuccessMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 1,
    y: 1,
    stroke: "currentColor",
    strokeWidth: 2,
    rx: 9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 1,
    y: 1,
    strokeWidth: 2,
    stroke: "currentColor",
    rx: 9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 9,
    x: 14.28,
    y: 6.46,
    stroke: "currentColor",
    rx: 0.5,
    transform: "rotate(45 14.28 6.46)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 5.07,
    x: 5.02,
    y: 9.95,
    stroke: "currentColor",
    rx: 0.5,
    transform: "rotate(-45 5.02 9.95)"
  })));
};
export default SvgSuccessMark;